const state = {
  drawer: true,
  dialog: {
    status: false,
    title: '',
    message: ''
  },
  dashboardView: 'card'
}

const getters = {
  drawer: (state) => state.drawer,
  dialog: (state) => state.dialog,
  dashboardView: (state) => state.dashboardView
}

const actions = {
  toggleDrawer ({ commit }, status) {
    commit('setDrawer', status)
  },
  toggleDialog ({ commit }, payload) {
    commit('setDialog', payload)
  },
  toggleDashboardView ({ commit }, payload) {
    commit('setDashboardView', payload)
  }
}

const mutations = {
  setDrawer: (state, status) => (state.drawer = status),
  setDialog: (state, payload) => (state.dialog = payload),
  setDashboardView: (state, payload) => (state.dashboardView = payload)
}

export default {
  state,
  getters,
  actions,
  mutations
}
